import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      await login(email, password);
      navigate('/admin');
    } catch (err) {
      setError('Credenciales incorrectas o error de conexión');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {/* Logo agregado aquí */}
        <div className="logo-container">
          <img 
            src="/logo1024.png" 
            alt="Logo" 
            className="login-logo"
          />
        </div>
        
        <h2 className="login-title">
          <i className="bi bi-box-arrow-in-right me-2"></i>
          Iniciar Sesión
        </h2>
        
        {error && (
          <div className="error-message">
            <i className="bi bi-exclamation-triangle-fill"></i>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="input-icon mb-4">
            <i className="bi bi-envelope"></i>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              placeholder="Correo electrónico"
              required
              disabled={loading}
            />
          </div>
          
          <div className="input-icon mb-4">
            <i className="bi bi-lock"></i>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              placeholder="Contraseña"
              required
              disabled={loading}
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="login-button"
          >
            {loading ? (
              <>
                <i className="bi bi-arrow-repeat animate-spin"></i>
                Iniciando...
              </>
            ) : (
              <>
                <i className="bi bi-box-arrow-in-right"></i>
                Iniciar Sesión
              </>
            )}
          </button>
        </form>

        <div className="mt-4 text-center text-sm text-gray-600">
          <p className="mt-1">
            <a href="/forgot-password" className="text-blue-500 hover:underline">
              ¿Olvidaste tu contraseña?
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;